import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  maincont: {
    backgroundColor: "#03321A",
    borderRadius: "32px 32px 0px 0px",
    marginTop: "54px"
  },
  featurecont: {
    maxWidth: "1420px",
    margin: "auto",
    color: "#FFF !important"
  },
  contmargin: {
    marginInline: "58px",
    paddingBlock: "40px",
    "@media (max-width: 430px)": {
        marginInline: "20px",
        paddingBottom: "20px",
      },
    "& hr": {
        marginBlock: "22px 40px"
    }
  },
  content: {
    maxWidth: "1074px",
    margin: "auto",
    textAlign: "center",
    color: "white",
    "& h4": {
      maxWidth: "776px",
      margin: "auto",
    },
  },
  footercont: {
    display: "flex",
    gap: "16px",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width: 700px)": {
        flexDirection: "column",
        alignItems: "flex-start"
    }
  },
  firstcont: {
    maxWidth: "400px",
    "& h4": {
      fontSize: "24px",
      fontWeight: "700",
      maxWidth: "337px"
    },
  },
  itembtn: {
    display: "flex",
    gap: "16px",
    // justifyContent: "center",
    marginTop: "16px",
    "& a": {
      display: "inline-block",
      textDecoration: "none",
      transition: "opacity 0.3s ease",
      "&:hover": {
        opacity: 0.8
      }
    }
  },
  itembtnright: {
    display: "flex",
    gap: "16px",
    // justifyContent: "center",
    marginTop: "16px",
    "@media (min-width: 700px) and (max-width: 1000px)": {
        flexDirection: "column"
    },
    "@media (max-width: 340px)": {
        flexDirection: "column",
        alignItems: "flex-start"
    }
  },
  terms: {
    display: "flex",
    gap: "40px",
    "& p": {
        marginBlock: "0px"
    },
    "& a": {
      color: "#FFF",
      textDecoration: "none",
      transition: "opacity 0.3s ease",
      "&:hover": {
        opacity: 0.8,
        textDecoration: "underline"
      }
    }
  },
  footerflex: {
    display: "flex",
    gap: "14px",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width: 540px)": {
        flexDirection: "column",
        alignItems: "flex-start"
    }
  },
  footerYear: {
    color: "#fff",
    padding: "10px 20px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "6px"
  },
}));
